import React from 'react';
import Box from '@material-ui/core/Box';
import { CHILDREN_PROPTYPES } from 'base/constants/propTypes';
import Rule from 'base/ui_components/Rule';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

/* this container displays a rule only on mobile */

const RuleContainer = ({ children }) => {
  const theme = useTheme();
  const isMediumAndUp = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <Box position="relative">
      {!isMediumAndUp && <Rule />}
      {children}
    </Box>
  );
};

RuleContainer.propTypes = {
  children: CHILDREN_PROPTYPES
};

export default RuleContainer;
